//@ts-strict-ignore
import React from 'react';
import Workspace from '../../components/Workspace/Workspace';
import { NominalAccrualPrepayment } from '../../graphql/entities';
import Formatters from '../../components/grid-addons/formatters';
import fieldMetaData from '../../graphql/schema/fieldMetaData';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import { Direction } from '../../graphql/schema/p4types';
import { IWorkspaceColumnOverride } from '../../@types/workspaceTypes';
import { IEditableDataGridColumnDef } from '../../@types/editableDataGridTypes';

const NOMINAL_ACCRUAL_PREPAYMENT_COLUMN_OVERRIDES: IWorkspaceColumnOverride = {
  documentNumber: {
    name: 'Document No',
    key: 'documentNumber',
    width: 110,
  },
  documentDate: {
    name: 'Document Date',
    key: 'documentDate',
    formatter: 'date',
    width: 120,
  },
  AccrualPrepaymentType: {
    name: 'Type',
    key: 'accrualPrepayment',
    formatter: Formatters.EnumFormatter,
    width: 120,
    options: fieldMetaData.AccrualPrepaymentType,
  },
  documentReference: {
    name: 'Reference',
  },
  documentStatus: {
    name: 'Status',
    width: 80,
    formatter: Formatters.DocumentStatusFormatter,
  },
  totalValue: {
    name: 'Total Value',
    key: 'totalValue',
    formatter: Formatters.NumericFormatter,
    width: 140,
    options: {
      format: { decimals: 2 },
    },
    sortable: false,
  },
};

const NOMINAL_ACCRUAL_PREPAYMENT_FIELD_NAMES = [
  'documentDate',
  'documentNumber',
  'accrualPrepayment',
  'documentStatus',
  'documentReference',
  'totalValue',
];

const { readOnlyStatus, formUrl, type, title, workspace } = NominalAccrualPrepayment;

const availableFiltersFilter = (column: IEditableDataGridColumnDef) => {
  return column?.fieldName && !column.fieldName.endsWith('totalValue');
};

const NominalAccrualPrepaymentWorkspace = (props) => {
  const workspaceProps = useWorkspace(props, NominalAccrualPrepayment, {
    columns: NOMINAL_ACCRUAL_PREPAYMENT_FIELD_NAMES,
    columnOverrides: NOMINAL_ACCRUAL_PREPAYMENT_COLUMN_OVERRIDES,
    initialSortColumn: 'documentNumber',
    initialSortDirection: Direction.Desc,
  });

  return (
    <Workspace
      entityType={type}
      formUrl={formUrl}
      title={title}
      defaultQuery={workspace}
      readOnlyStatus={readOnlyStatus}
      availableFiltersFilter={availableFiltersFilter}
      {...workspaceProps}
      {...props}
      entity={NominalAccrualPrepayment}
    />
  );
};

export default NominalAccrualPrepaymentWorkspace;
